import React, {FC} from 'react'
import Label from '../label'
import {Container, Button, RadioLabel} from './styles'
import { ErrorText } from '../input/styles'
import { getIn } from 'formik'

type ButtonProps = {
  title:string,
  value:string,
  id?:string,
  disabled?:boolean,
}

type RadioProps = {
  isSmall?:boolean,
  buttons:ButtonProps[],
  selectedButton:string,
  onChange:(value:any) => void,
  title:string
  toolTip?:boolean,
  tooltipText?:any,
  disabled?:boolean
  fieldName?:string,
  errors?:any,
  touched?:any,
  required?:boolean,
}

const RadioButtonGroup:FC<RadioProps> = (props) => {
  const {
    isSmall,
    buttons,
    selectedButton,
    onChange,
    title,
    toolTip=false,
    tooltipText,
    disabled,
    fieldName,
    errors,
    touched,
    required,
  } = props
  const fieldError = fieldName ? getIn(errors, fieldName) : undefined
  const fieldTouched = fieldName ? getIn(touched, fieldName) : undefined
  const displayedError = fieldTouched && fieldError
  return(
    <>
      {title &&
        <RadioLabel>
          <Label required={required} title={title} toolTip={toolTip} tooltipText={tooltipText} />
        </RadioLabel>
      }
      <Container
        role="radiogroup"
        aria-label={typeof title === 'string' ? title : undefined}
        aria-invalid={Boolean(displayedError)}
        data-validation-field={fieldName}
        data-validation-error={displayedError ? true : undefined}
        disabled={disabled}
        isSmall={isSmall}
      >
        {buttons.map((item:ButtonProps) => (
          <Button
            key={item.id}
            type="button"
            role="radio"
            active={item.value === selectedButton}
            aria-checked={item.value === selectedButton}
            onClick={disabled || item.disabled ? undefined : () => onChange(item.value)}
            isSmall={isSmall}
            disabled={disabled || item.disabled}
          >
            {item.title}
          </Button>
        ))}
      </Container>
      {displayedError ? <ErrorText>{displayedError}</ErrorText> : null}
    </>
  )
}

export default RadioButtonGroup
